import { request as requestIdleCallbackShim } from "requestidlecallback";
import _window from "@src/libraries/window";
import LocalStorage from "@src/libraries/LocalStorage";
import { IS_CRAWLER } from '@src/assets/js/device';
import { silentReport } from "./report";
export let API_V2_URL = process.env.API_V2_URL || "https://api-v2.comoquiero.net";
const subdomain = _window.location && _window.location.host.split(".").shift() || "";
if (/(^|-)ali$/.test(subdomain) || /(^|-)alicorp$/.test(subdomain) || /(^|-)diariamenteali$/.test(subdomain)) {
    API_V2_URL = "https://api-alicorp.comoquiero.net";
}
export let APP_URL = process.env.APP_URL || "https://comoquiero.net";
export function formatNumber(value, maxDecimals) {
    if (!value)
        return "" + value;
    const parts = value.toString().split(/\.|,/);
    if (parts.length > 2)
        return "" + value;
    const integer = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    let decimal = parts[1] || "";
    if (decimal && "number" === typeof maxDecimals) {
        decimal = (parts[1] || "").substring(0, maxDecimals);
    }
    decimal = decimal ? "," + decimal : "";
    return integer + decimal;
}
export function formatPrice(value, maxDecimals) {
    maxDecimals = 2;
    return formatNumber(value, maxDecimals);
}
export function isType(value, type) {
    if (!value)
        return true;
    const isType = "[object " + type + "]" === Object.prototype.toString.call(value);
    if (!isType)
        console.warn("!isType", type, value);
    return isType;
}
export async function windowLoad() {
    const document = _window.document;
    const addEventListener = _window.addEventListener;
    if (document && document.readyState !== "complete") {
        return new Promise(function (resolve) {
            addEventListener && addEventListener("load", function (event) {
                resolve("");
            });
        });
    }
    await timeout(1);
}
export async function crawlersLoad() {
    await windowLoad();
    await timeout(10000);
}
export function timeout(ms = 0) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
export async function requestIdleCallback(ms) {
    await windowLoad();
    return new Promise(resolve => requestIdleCallbackShim(resolve, ms));
}
export function eventCallback(event) {
    const addEventListener = _window.addEventListener;
    if (!addEventListener)
        return;
    return new Promise(resolve => addEventListener(event, resolve, false));
}
export function timestampDate(date) {
    if (!date)
        return;
    const arr = date.split(/[- :]/);
    return new Date(Number(arr[0]), Number(arr[1]) - 1, Number(arr[2]), Number(arr[3]), Number(arr[4]), Number(arr[5]));
}
export function dateTimestamp(date) {
    const year = date.getUTCFullYear();
    let yearString = year + "-";
    if (new Date().getFullYear() == year) {
        yearString = "";
    }
    return yearString +
        ('00' + (date.getUTCMonth() + 1)).slice(-2) + '-' +
        ('00' + date.getUTCDate()).slice(-2) + ' ' +
        ('00' + date.getUTCHours()).slice(-2) + ':' +
        ('00' + date.getUTCMinutes()).slice(-2);
}
export function DOMContentLoaded() {
    return new Promise(function (resolve) {
        const document = _window.document;
        if (!document)
            return;
        document.addEventListener("DOMContentLoaded", () => {
            resolve("");
        });
        if (document.readyState === "complete" || document.readyState === "interactive") {
            resolve("");
        }
    });
}
export function push(arr, push) {
    if (!Array.isArray(push)) {
        push = [push];
    }
    const jsonArr = arr.map(function (el) {
        return stringify(el);
    });
    for (const el of push) {
        if (!jsonArr.includes(stringify(el))) {
            arr.push(el);
        }
    }
    return arr;
}
const SCRIPTS = {};
export function getScript(src) {
    if (SCRIPTS[src])
        return SCRIPTS[src];
    SCRIPTS[src] = new Promise(function (resolve, reject) {
        const document = _window.document;
        if (!document)
            return false;
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.onload = function () {
            resolve("");
        };
        script.onerror = function () {
            delete SCRIPTS[src];
            reject("");
        };
        script.src = src;
        document.body.appendChild(script);
    });
    return SCRIPTS[src];
}
export function markdown(txt) {
    if (!txt)
        return "";
    return txt.replace(/\*\*([^*]*)\*\*/g, "<b>$1</b>");
}
;
export function imagefy(inputText) {
    const replacePattern = /(^| )([a-zA-Z0-9\:\/\.\-\_]+(\.jpg|\.jpeg|\.png|\.svg))( |$)/gim;
    return inputText.replace(replacePattern, '$1<img src="$2"/>$4');
}
export function scalefy(str, scale) {
    const regex = /(^| )~([0-9]+([.,][0-9]+)?)/gim;
    return str.replace(regex, function (match, $1, $2) {
        return $1 + ($2.replace(/,/g, ".") * scale);
    });
}
export function recipeDiners(recipe, defaultDiners) {
    if (recipe && !recipe.scalable) {
        return recipe.people;
    }
    if (recipe && 0 != (defaultDiners % recipe.people)) {
        let dinersRecipe = recipe.people;
        while (true) {
            if (dinersRecipe < defaultDiners) {
                dinersRecipe += recipe.people;
            }
            else {
                break;
            }
        }
        return dinersRecipe;
    }
    return defaultDiners;
}
export function headerAttr(headers, headerName, attr) {
    if (!headers || !headerName || !attr) {
        return;
    }
    const header = headers[headerName];
    if (!header) {
        return;
    }
    const regeEx = new RegExp(".*max-age=([0-9]+).*");
    const match = header.match(regeEx);
    if (match) {
        return match[1];
    }
}
export function deepCopy(data) {
    return parse(stringify(data));
}
export function objectFilter(obj, predicate) {
    return Object.keys(obj)
        .filter(key => predicate(obj[key]))
        .reduce((res, key) => (res[key] = obj[key], res), {});
}
export function capitalize(str) {
    if (!str) {
        return "";
    }
    str = str.toString().toLowerCase();
    return str.charAt(0).toUpperCase() + str.slice(1);
}
export function stringify(data, ...args) {
    if ("undefined" === typeof data) {
        return "";
    }
    if ("string" == typeof data) {
        return "" + data;
    }
    try {
        return JSON.stringify(data, ...args) || "";
    }
    catch (e) {
        console.warn("!stringify", data);
    }
    return "";
}
export function parse(str) {
    if (!str) {
        return;
    }
    try {
        return JSON.parse(str);
    }
    catch (e) {
    }
}
export function fakePromise(promise) {
    return {
        then(thenCallback) {
            let error;
            try {
                promise(thenCallback);
            }
            catch (e) {
                error = e;
            }
            return {
                catch(callback) {
                    if (callback && error) {
                        callback(error);
                    }
                }
            };
        }
    };
}
export function appendLink(href, callback) {
    const document = _window.document;
    if (!document) {
        return;
    }
    const link = document.createElement("link");
    link.addEventListener("load", function () {
        if (callback) {
            callback();
        }
    });
    link.type = "text/css";
    link.rel = "stylesheet";
    link.href = href;
    document.head.appendChild(link);
    return link;
}
export function appendLinkContent(content) {
    const document = _window.document;
    if (!document) {
        return;
    }
    const link = document.createElement("style");
    link.type = "text/css";
    link.innerHTML = content;
    document.head.appendChild(link);
    return link;
}
export function visibilityUpdate(callback) {
    const doc = _window.document;
    if (!doc)
        return;
    let hidden = "hidden";
    if ("hidden" in doc) {
        doc.addEventListener("visibilitychange", onchange);
    }
    else if ("mozHidden" in doc) {
        hidden = "mozHidden";
        doc.addEventListener("mozvisibilitychange", onchange);
    }
    else if ("webkitHidden" in doc) {
        hidden = "webkitHidden";
        doc.addEventListener("webkitvisibilitychange", onchange);
    }
    else if ("msHidden" in doc) {
        hidden = "msHidden";
        doc.addEventListener("msvisibilitychange", onchange);
    }
    else if ("onfocusin" in doc) {
        doc.onfocusin = doc.onfocusout = onchange;
    }
    else {
        _window.onpageshow = _window.onpagehide = _window.onfocus = _window.onblur = onchange;
    }
    function onchange(evt) {
        const evtMap = {
            focus: false, focusin: false, pageshow: false, blur: true, focusout: true, pagehide: true
        };
        evt = evt || _window.event;
        if (evt.type in evtMap) {
            const isHidden = evtMap[evt.type];
            callback(!isHidden);
        }
        else {
            const isHidden = doc[hidden];
            callback(!isHidden);
        }
    }
}
;
export async function pageShow() {
    return new Promise(function (resolve) {
        visibilityUpdate(function (visible) {
            if (visible) {
                resolve();
            }
        });
    });
}
export function normalize(txt) {
    if (!txt)
        return "";
    let normalized = txt;
    try {
        normalized = txt.normalize("NFD");
    }
    catch (e) {
    }
    return normalized.replace(/[\u0300-\u036f]/g, "")
        .trim()
        .toLowerCase()
        .replace(/[ |-|(|)|'|"|\.|,|\/|?|=]+/gi, "_")
        .replace(/^_|_$/, "");
}
export async function reload(all) {
    const location = _window.location;
    if (!location)
        return false;
    const time = 10000;
    const searchReloadMatch = location.search.match(/reload=[^&#]+/);
    const searchReload = searchReloadMatch && searchReloadMatch[0];
    const reload = Number(LocalStorage.getItem("reload") || searchReload);
    const now = (new Date()).getTime();
    if (reload && now - reload < time) {
        await silentReport("utils reload fail");
        return false;
    }
    LocalStorage.setItem("reload", "" + now);
    await timeout(1);
    location.replace(location.origin + location.pathname + "?reload=" + now);
    return true;
}
export function localeMatch(locale) {
    if (!locale)
        return;
    const match = locale.match(/^([a-zA-Z]{2,3})?-?([a-zA-Z]{2})?$/);
    if (!match || !match[0])
        return;
    const localeArr = locale.split("-");
    const lang = localeArr[0];
    if ("adm" == lang)
        return;
    return match;
}
export function isProduction() {
    if (IS_CRAWLER)
        return true;
    const location = _window.location;
    const host = location && location.host;
    if (!host)
        return false;
    if ((!host.includes("comoquiero.cl") && !host.includes("comoquiero.net"))
        || host.startsWith("dev.")
        || host.startsWith("v2.")
        || host.startsWith("beta.")
        || host.startsWith("testing.")
        || host.startsWith("admin.")) {
        return false;
    }
    return true;
}
export function timeSince(date) {
    var seconds = Math.floor(Date.now() / 1000 - date);
    var interval = seconds / 31536000;
    if (interval > 1) {
        return Math.floor(interval) + " years";
    }
    interval = seconds / 2592000;
    if (interval > 1) {
        return Math.floor(interval) + " months";
    }
    interval = seconds / 86400;
    if (interval > 1) {
        return Math.floor(interval) + " days";
    }
    interval = seconds / 3600;
    if (interval > 1) {
        return Math.floor(interval) + " hours";
    }
    interval = seconds / 60;
    if (interval > 1) {
        return Math.floor(interval) + " min";
    }
    return Math.floor(seconds) + " sec";
}
